/**
 * Правый инспектор: свойства / карточка / анализ / оверлеи.
 */
import type { ReactNode } from "react";
import { SectionHelpTooltip } from "@/components/shared/SectionHelpTooltip";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TacticalSideRail } from "./TacticalSideRail";

type Props = {
  hasSelection: boolean;
  properties: ReactNode;
  card: ReactNode;
  analysis: ReactNode;
  overlays: ReactNode;
  defaultTab?: string;
  collapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
  widthPx: number;
  onWidthChange: (widthPx: number) => void;
};

export function TacticalRightInspector({
  hasSelection,
  properties,
  card,
  analysis,
  overlays,
  defaultTab = "properties",
  collapsed,
  onCollapsedChange,
  widthPx,
  onWidthChange,
}: Props) {
  return (
    <TacticalSideRail
      side="right"
      title="Инспектор"
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      widthPx={widthPx}
      onWidthChange={onWidthChange}
      headerExtra={
        <SectionHelpTooltip label="Справка: инспектор">
          <p>
            Справа — свойства выбранной фичи, карточка шаблона, инструменты анализа и оверлеи.
            Слева — доска и организация объектов.
          </p>
          <ul className="list-disc space-y-1 pl-4">
            <li>Свойства: подпись и стиль карты.</li>
            <li>Карточка: атрибуты по шаблону (card_values).</li>
            <li>Анализ: плагины (measure, viewshed, buffer…).</li>
            <li>Оверлеи: справочные слои и heatmap.</li>
            <li>Стрелки сворачивают панель; левый край — изменить ширину.</li>
            <li>Esc снимает выбор на карте.</li>
          </ul>
        </SectionHelpTooltip>
      }
    >
      <Tabs defaultValue={defaultTab} className="flex min-h-0 flex-1 flex-col">
        <TabsList className="mx-2 mt-2 grid h-auto grid-cols-2 gap-1">
          <TabsTrigger value="properties" className="text-[10px]">
            Свойства
          </TabsTrigger>
          <TabsTrigger value="card" className="text-[10px]">
            Карточка
          </TabsTrigger>
          <TabsTrigger value="analysis" className="text-[10px]">
            Анализ
          </TabsTrigger>
          <TabsTrigger value="overlays" className="text-[10px]">
            Оверлеи
          </TabsTrigger>
        </TabsList>
        <div className="min-h-0 flex-1 overflow-y-auto p-2">
          <TabsContent value="properties" className="mt-0 space-y-2">
            {!hasSelection && (
              <p className="text-[10px] text-muted-foreground">Нет выбора — укажите фичу.</p>
            )}
            {properties}
          </TabsContent>
          <TabsContent value="card" className="mt-0 space-y-2">
            {!hasSelection ? (
              <p className="text-[10px] text-muted-foreground">Выберите одну фичу для карточки.</p>
            ) : (
              card
            )}
          </TabsContent>
          <TabsContent value="analysis" className="mt-0 space-y-2">
            {analysis}
          </TabsContent>
          <TabsContent value="overlays" className="mt-0 space-y-2">
            {overlays}
          </TabsContent>
        </div>
      </Tabs>
    </TacticalSideRail>
  );
}
